const actions = {
  getApps({ state, commit }, data) {
    return new Promise((result, reject) => {
      let url = 'api/app';
      const page = data && data.page ? data.page : 1;
      url += `?term=${state.filters.term}`;
      url += `&category_id=${state.filters.category_id}`;
      url += `&page=${page}`;

      window.$axios.get(url)
        .then((response) => {
          commit('setApps', response.data);
          result(response.data);
        })
        .catch(() => {
          reject();
        });
    });
  },
  setFilterTerm({ commit }, term) {
    commit('setFilterTerm', term);
  },
  setFilterCategoryId({ dispatch, commit }, data) {
    return new Promise((result, reject) => {
      commit('setFilterCategoryId', data.id);
      commit('clearFilterTerm', data.id);

      dispatch('getApps')
        .then(() => {
          result();
        })
        .catch(() => {
          reject();
        })
    });
  }
}
export default actions;
